import { Flex } from "antd";
import styled from "styled-components";

export const BomWrap = styled(Flex)`
  
`